import { Cloudinary } from '@cloudinary/url-gen'

const createCloudinary = () => {
  return new Cloudinary({
    cloud: {
      cloudName: 'youspeak',
    },
  })
}

export default createCloudinary